import {
  AssemblyTypeValue,
  JobFormDataBackflow,
  RpCheck2Type,
  TestRepair,
  TestResult,
} from '../../types/jobFormData';
import { ValidationStatus } from './form-builder';
import { AnyForm } from './form-definitions';
import { evaluateBackflowForm, initTestForm } from './evaluate';
import { validateTestDate, validateTestTimestamp } from './helpers';

export type ValidationResult = {
  valid: boolean;
  errors: string[];
};

// Incomplete test fields become submission errors so callers that only
// consume {valid, errors} can report why the form is not submittable.
const incompleteFieldErrors = (form: AnyForm): string[] =>
  Object.values(form.fields)
    .filter((field) => field?.status === ValidationStatus.INCOMPLETE)
    .map(({ label, message }) =>
      message ? `${label}: ${message}` : `${label} is required`
    );

export const validateBackflowTest = (
  testData: JobFormDataBackflow,
  rpCheck2Type: RpCheck2Type = 'USC10'
): ValidationResult => {
  const evaluation = evaluateBackflowForm(testData || {}, { rpCheck2Type });
  // A non-testable job doesn't require test values, so leftover partial test
  // entries must not surface as errors there.
  const forms = evaluation.unableToTest
    ? []
    : [evaluation.form.initial, evaluation.form.final];
  return {
    valid: evaluation.valid,
    errors: [...evaluation.errors, ...forms.flatMap(incompleteFieldErrors)],
  };
};

export const validateTestResult = (
  testAttempt: TestResult | TestRepair,
  backflowAssemblyType: AssemblyTypeValue,
  rpCheck2Type: RpCheck2Type = 'USC10'
): string[] => {
  const errors = [
    ...validateTestDate(testAttempt.testDate),
    ...validateTestTimestamp(testAttempt.timestamp),
  ];
  if (testAttempt.type === 'repair') {
    if (!`${testAttempt.comment ?? ''}`.trim()) {
      errors.push('Repair comments are required');
    }
    return errors;
  }
  return [
    ...errors,
    ...incompleteFieldErrors(
      initTestForm(testAttempt, backflowAssemblyType, rpCheck2Type)
    ),
  ];
};
